<template>
  <div id="section__carousel">
    <b-carousel :id="carouselId" indicators>
      <!-- class="d-none d-md-block" -->
      <b-carousel-slide
        v-for="(banner, index) in bigBannerImages"
        :key="index"
        :img-src="banner"
      ></b-carousel-slide>
    </b-carousel>
    <div>
      <section-button carouselBtn>{{ buttonText }}</section-button>
    </div>
  </div>
</template>

<script>
import Button from "../Shared/Button";
export default {
  props: {
    carouselId: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    bigBannerImages: {
      type: Array,
      required: true,
    },
  },
  components: {
    "section-button": Button,
  },
};
</script>
<style scoped>
#section__carousel {
  margin-bottom: 60px;
  position: relative;
}

#section__carousel >>> .carousel-indicators {
  justify-content: flex-start;
  margin: 0;
  bottom: -10px;
  left: 10%;
}

#section__carousel >>> .carousel-indicators li {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #777777;
  opacity: 1;
  border: 0;
}
.button--carousel {
  bottom: 0;
  right: 4%;
  width: 45%;
}

#section__carousel >>> .carousel-indicators .active {
  background-color: #ff2c2c;
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 767px) {
  #section__carousel >>> .carousel-indicators li {
    width: 12px;
    height: 12px;
  }

  #section__carousel {
    margin-bottom: 35px;
  }
  .button--carousel {
    bottom: -15px;
    right: 4%;
    width: 45%;
  }
}
</style>